
export default function CompanyStorySection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
              Our Story
            </div>

            <h2
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              We Are <strong>TREX RE LLC!</strong>
            </h2>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              A real estate investment company that buys and rents real estate in
              El Paso Texas. Since 2016, we've been helping homeowners throughout
              El Paso and surrounding areas sell their properties quickly and
              hassle‑free.
            </p>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              We buy houses in any condition, helping homeowners sell fast
              without the hassle. Whether you're facing foreclosure, dealing
              with an inherited property, going through a divorce, or simply
              need to relocate fast, we provide fair cash offers and close on
              your timeline.
            </p>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              So call us to sell your real estate today! We're here to make the
              process as smooth and stress‑free as possible.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="tel:+1-915-206-5814"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-teal-600 text-white rounded-lg font-bold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                <span>Call (915) 206-5814</span>
              </a>
              <a
                href="mailto:ElPaso@trexrealestate.com"
                className="inline-flex items-center space-x-2 px-8 py-4 border-2 border-teal-600 text-teal-600 rounded-lg font-bold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-fill"></i>
                <span>Email Us</span>
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[500px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/9c42d8da8480d91d46be8e99e0bafcbd.jpg"
                  alt="TRex RE LLC Team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white p-8 rounded-xl shadow-xl">
              <div className="text-5xl font-bold mb-1">10+</div>
              <div className="text-sm font-medium">Years in Business</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
